export type { TableBodyProps, TableBodySlots, TableBodyState } from './components/TableBody/index';
export {
  TableBody,
  renderTableBody_unstable,
  tableBodyClassName,
  tableBodyClassNames,
  useTableBodyStyles_unstable,
  useTableBody_unstable,
} from './components/TableBody/index';
